module.exports = __webpack_public_path__ + "static/img/logo2.13ebc060.png";